@if(skinning.initialized){
<app-main-layout [isMobile]="isMobile" [displayHeader]="layout.displayHeader()" [programme]="layout.programme()"
    (goHomeClicked)="goHome()" (searchOpened)="searchOpened($event)" class="app-wrapper flex flex-col">
    <details-shell></details-shell>
    @if(search()) {
    <asset-search class="search"></asset-search>
    }
</app-main-layout>
}

<splash #splash data-testid="app_splash"></splash>
<app-spinner></app-spinner>
<modal></modal>
@if(expandedMiniItem()){
<div>
    <mini-details #MiniDetails></mini-details>
</div>
}

<ng-template #playerTemplate>
    <player></player>
</ng-template>
<ng-container #playerContainer></ng-container>
<player-loading-spinner></player-loading-spinner>